import classes from './ProductDetails.module.scss';
import CommentsIcon from '../../../assets/icons/Comments.svg'
import VideoThumbnail from '../../../assets/VideoThumbnail.png'
import ProductGallery from '../../../components/ProductGallery/ProductGallery'
import { Rating } from 'react-simple-star-rating';
import ShoppingCart from '../../../assets/icons/ShoppingCart.svg';
import TestImage from '../../../assets/sample-image.png'
import FreeShipping from '../../../assets/icons/FreeShipping.svg';
import ChevronDown from '../../../assets/icons/ChevronDown.svg';
import FreeReturn from '../../../assets/icons/FreeReturn.svg';
import ArrowLeft from '../../../assets/icons/ArrowLeft.svg';
import SizeFit from '../../../assets/icons/SizeFit.svg';
import SecurePayment from '../../../assets/icons/SecurePayment.svg';
import { useEffect, useState } from "react";
import { ProductCard } from '../../../components/ProductCard/ProductCard';
import { useSearchParams } from 'react-router-dom';
import { ProductService } from '../../../services/ProductService';
import { globalErrorHandler } from '../../../utils/errorHandler';
import { useLoader } from '../../../customHooks/loader';
import { NonFormikDropdownComponent } from '../../../components/Inputs/Input';
import { useCart } from '../../../customHooks/cart';
import { toast } from 'react-toastify';
import { CartService } from '../../../services/CartService';

export const ProductDetails = () => {

    const [searchParams] = useSearchParams();
    const loader = useLoader();
    const skuId = searchParams.get('skuId');
    const [productDetails, setProductDetails] = useState({});
    const [selectedConfigs, setSelectedConfigs] = useState({});
    const [colors, setColors] = useState([]);
    const [sizes, setSizes] = useState([]);
    const cart = useCart();
    const { checkAndAddCart } = cart();

    const handleAddToCart = () => {
        CartService.addToCart(
            { skuId: selectedConfigs.skuId },
            handleAddToCartSuccess,
            globalErrorHandler,
            loader
        )
    }

    const handleAddToCartSuccess = ({ data }) => {
        checkAndAddCart(data.data.skuId);
        toast.success("Selected Item has been added to the cart");
    }


    const [previouslyLookedAt, setPreviouslyLookedAt] = useState([
        {
            sku: "123",
            image: TestImage,
            price: 123,
            itemName: "Abaya 1",
            category: "Abaya Category 1",
            addedToWishilist: false,
        },
        {
            sku: "123P",
            image: TestImage,
            price: 123,
            itemName: "Abaya 1",
            category: "Abaya Category 1",
            addedToWishilist: false,
        },
        {
            sku: "123PC",
            image: TestImage,
            price: 123,
            itemName: "Abaya 1",
            category: "Abaya Category 1",
            addedToWishilist: true,
        },
        {
            sku: "123b",
            image: TestImage,
            price: 123,
            itemName: "Abaya 1",
            category: "Abaya Category 1",
            addedToWishilist: false,
        },
    ]);

    useEffect(() => {
        getProductDetails();
        getProductList();
    }, []);

    const getProductDetails = () => {
        ProductService.getProductDetails(
            { skuId },
            handleProductDetailsSuccess,
            globalErrorHandler,
            loader
        )
    }

    const getProductList = () => {
        ProductService.getProductList(
            {},
            0,
            handleGetProductListSuccess,
            globalErrorHandler,
            loader,
            4,
        )
    }

    const handleGetProductListSuccess = ({ data }) => {
        console.log({ data });
        setPreviouslyLookedAt(data.data.products);
    }

    const handleProductDetailsSuccess = ({ data }) => {
        const productDetails = data.data.productDetails;
        console.log({ productDetails });
        // const prevProducts = productDetails.slice(0, 4);
        // setPreviouslyLookedAt(prevProducts);

        setProductDetails(productDetails);
        setColors([...new Set(productDetails.variationDetails.map(item => item.color))])
        setSelectedConfigs(productDetails.variationDetails[0]);
        setSizes([...new Set(productDetails.variationDetails.filter(variation => variation.color === productDetails.variationDetails[0].color).map(item => ({ label: String(item.sizes).toUpperCase(), value: item.sizes })))])
        console.log({ start: productDetails.variationDetails[0], sizes });
    }

    const itemDetails = {
        userRating: 3,
        userComments: 120,
        price: 70.78,
        colors: ["red", "green", "yellow", "maroon"],
        features: [1, 2, 3, 4],
        itemDescription: "100% Bio-washed Cotton - makes the fabric extra soft & silky. Flexible ribbed crew neck. Precisely stitched with no pilling & no fading. Provide  all-time comfort. Anytime, anywhere. Infinite range of matte-finish HD prints. 100% Bio-washed Cotton – makes the fabric extra soft & silky. Flexible ribbed crew neck. Precisely stitched with no pilling & no fading. Provide  all-time comfort. Anytime, anywhere. Infinite range of matte-finish HD prints."
    }

    const FEATURES = [
        {
            id: 1,
            image: SecurePayment,
            title: "Secure Payment",
        },
        {
            id: 2,
            image: FreeReturn,
            title: "Free Return",
        },
        {
            id: 3,
            image: FreeShipping,
            title: "Free Shipping",
        },
        {
            id: 4,
            image: SizeFit,
            title: "Size Fit Guarantee",
        },
    ]

    const onConfigChange = (label, value) => {
        console.log({ value, label });
        const currentConfig = selectedConfigs;
        switch (label) {
            case "color": {
                setSizes([...new Set(productDetails.variationDetails.filter(variation => variation.color === value).map(item => ({ label: String(item.sizes).toUpperCase(), value: item.sizes })))]);
                const newSelectedVariations = productDetails.variationDetails.filter(variation => variation.color === value)[0];
                console.log({ newSelectedVariations, sizes })
                setSelectedConfigs(newSelectedVariations)
                break;
            }
            case "sizes": {
                let newSelectedVariations;

                newSelectedVariations = productDetails.variationDetails.filter(variation =>
                    (label === "sizes" && variation.sizes === value && variation.color === currentConfig.color)
                )[0];
                if (!newSelectedVariations) {
                    newSelectedVariations = productDetails.variationDetails.filter(variation => variation.color === currentConfig.color)[0];
                }
                console.log({ newSelectedVariations })
                setSelectedConfigs(newSelectedVariations)
                break;
            }
            default: {

            }
        }

    }

    const wishlistOnClick = (sku) => {

        console.log(sku, "clicked to add to wishlist");

        let newList = previouslyLookedAt.map(item => ({
            ...item,
            addedToWishilist: item.sku === sku ? !item.addedToWishilist : item.addedToWishilist
        }))

        setPreviouslyLookedAt(newList);
    }
    return (
        productDetails.id ? <>
            <div className={classes.ProductDetails}>
                <div className={classes.ProductGallery}>
                    <ProductGallery images={[...productDetails.productImages, ...productDetails.productImages]} />
                </div>
                <div className={classes.ProductInfo}>
                    {/* <div className={classes.NavHeader}> Shop &gt; Women &gt; Top</div> */}
                    <div className={classes.ProductName}>{productDetails.productName}</div>
                    <div className={classes.ProductDesigner}>{productDetails.designerName}</div>
                    <div className={classes.Reviews}>
                        <Rating size="18" initialValue={itemDetails.userRating} readonly />
                        {itemDetails.userRating}
                        <img src={CommentsIcon} className={classes.Comment} alt='comments' />
                        {itemDetails.userComments} Reviews
                    </div>
                    <div className={classes.ProductSizeSelector}>
                        <div className={classes.ProductSizeSelectorHeader}>
                            Select Size
                            <div className={classes.SizeGuideText}>
                                <div>Size Guide</div>
                                <img src={ArrowLeft} alt='arrow left' />
                            </div>
                        </div>
                        <div className={classes.ProductSizeSelectorInput}>
                            <NonFormikDropdownComponent
                                name='sizes'
                                defaultValue={selectedConfigs.sizes}
                                values={sizes}
                                callback={(value, label) => onConfigChange("sizes", value)}
                            />
                        </div>
                    </div>
                    <div className={classes.Colors}>
                        <div className={classes.ColorsAvailable}>Color:</div>
                        <div className={classes.ColorOptions}>
                            {colors.map(color => (
                                <div
                                    className={`${classes.ColorSample} ${selectedConfigs.color === color ? classes.SelectedColor : ""}`}
                                    onClick={() => onConfigChange("color", color)}
                                    style={{ backgroundColor: color }}></div>
                            ))}
                        </div>
                    </div>
                    <div className={classes.Action}>
                        <div className={classes.AddToCart} onClick={handleAddToCart}>
                            <img src={ShoppingCart} alt='add to cart' /> Add to cart
                        </div>
                        <div className={classes.ItemPrice}>د.إ {selectedConfigs.productPrice}</div>
                    </div>
                    <div className={classes.ProductFeatures}>
                        {FEATURES.filter(({ id }) => itemDetails.features.includes(id)).map(feature => (
                            <div className={classes.FeatureContainer}>
                                <img src={feature.image} className={classes.FeatureImage} alt={feature.title} />
                                <div className={classes.FeatureTitle}>{feature.title}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className={classes.ProductDescription}>
                <div>
                    <div className={classes.descriptionHeader}>Product Description</div>
                    <p className={classes.description}>{productDetails.productDescription}</p>
                </div>
                <video src={productDetails.productVideos[0]} autoPlay alt='video' className={classes.VideoThumbnail} />
            </div>
            <div className={classes.previouslyLookedAt}>
                <div className={classes.heroHeader}>Previously looked at</div>
                <div className={classes.products}>
                    {previouslyLookedAt.length ? previouslyLookedAt.map((item) => {
                        return (
                            <ProductCard
                                itemDetails={item}
                                showWishlistButton
                                wishlist={item.addedToWishilist}
                                wishlistOnClick={wishlistOnClick}
                            />
                        )
                    }) : null}
                </div>
            </div>
        </> : null
    )
}
